export default __webpack_public_path__ + "static/media/hip_hop_dancing.f8589d0f.gif";